import { NAME } from './constants';

export const SET_FILTER = `${NAME}/setFilter`;
export const SET_COLUMNS = `${NAME}/setColumns`;
